<div class="inputTitle" *ngIf="label" #title>
  <span>{{label}} <i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>
<!-- @TODO New Super Location View -->
<div class="superLocationbtn">
  <button mat-raised-button class="Save" [disabled]="!isEditable" (click)="openDialog()">{{data?.length ? 'Edit' :
    'Add'}} Location(s)</button>
</div>

<div class="locationsGrid" [class.lightningBorder]="beLight" *ngIf="data?.length" [class.truncate]="truncateList"
  [class.errorBorderIntellisense]="errors?.length" #portsListDiv>
  <span class="metadata">Selected {{this.data?.length}} Ports</span>
  <span *ngFor="let item of data">{{item?.name_display}} <i *ngIf="isEditable" class="flaticon-close"
      (click)="removePort(item)"></i></span>

</div>
<div class="view-more" *ngIf="data?.length > 4" (click)="toggleTruncate()">
  <span>{{truncateList ? 'Expand' : 'Collapse'}} ...</span>
</div>